var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NNBrandIcon } from '@marketing-icons';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { foregroundToBackgroundColorMap } from '@marketing/variables';
import { clsx } from 'clsx';
import { Link } from 'react-router';
import ProgressBar from './ProgressBar';
function Header() {
    var currentStep = useProfileContext().currentStep;
    var backgroundColorStyle = foregroundToBackgroundColorMap[currentStep.theme === 'dark' ? 'squash' : 'beige'];
    var paddingStyle = 'px-4 py-3 md:px-15 md:py-5';
    var flexStyles = 'w-full md:max-w-2xl  mx-auto flex flex-col md:flex-row justify-start items-start gap-4 md:items-center';
    var Icon = _jsx(NNBrandIcon, { className: "text-icon-dark w-[59px] md:w-[80px] h-[40px] md:h-[54px]" });
    return (_jsx("header", __assign({ className: clsx(backgroundColorStyle, 'border-b border-solid border-shoe') }, { children: _jsxs("div", __assign({ className: clsx(flexStyles, paddingStyle) }, { children: [_jsx(Link, __assign({ to: "/", viewTransition: true }, { children: Icon })), currentStep.section && currentStep.section !== 'start' && (_jsx("div", __assign({ className: "w-full flex-grow" }, { children: _jsx(ProgressBar, {}) }))), _jsx("div", { className: "hidden md:block md:size-[54px]" })] })) })));
}
export default Header;
